export default function(fetch) {
  return function() {
    const apiResources = fetch(`${process.env.REACT_APP_API_URL}/products/sets`)
    const systemResources = fetch('/mocks/products.json')

    return Promise.all([apiResources, systemResources])
      .then(([api, system]) => Promise.all([api.json(), system.json()]))
      .then(([api, system]) => [...api, ...system])
  }
}



// WEBPACK FOOTER //
// ./src/repositories/getProducts.js